import state from './state';
import actions from './actions';
import mutations from './mutations';

const ecotronStore = {
  namespaced: true,
  state,
  actions,
  mutations
};

export default ecotronStore;
